import { Badge } from "@/components/ui/badge";
import { PROPOSAL_STATUS_LABELS, type ProposalStatus } from "@shared/proposals";

const STYLES: Record<ProposalStatus, string> = {
  draft: "bg-slate-100 text-slate-700 dark:bg-slate-800 dark:text-slate-300 border-transparent",
  pending_approval: "bg-amber-100 text-amber-800 dark:bg-amber-900/40 dark:text-amber-300 border-transparent",
  approved: "bg-emerald-100 text-emerald-800 dark:bg-emerald-900/40 dark:text-emerald-300 border-transparent",
  rejected: "bg-red-100 text-red-800 dark:bg-red-900/40 dark:text-red-300 border-transparent",
  sent: "bg-blue-100 text-blue-800 dark:bg-blue-900/40 dark:text-blue-300 border-transparent",
  accepted: "bg-emerald-600 text-white border-transparent",
  declined: "bg-slate-600 text-white border-transparent",
};

export default function ProposalStatusBadge({ status }: { status: string }) {
  const s = status as ProposalStatus;
  return (
    <Badge variant="outline" className={STYLES[s] ?? ""}>
      {PROPOSAL_STATUS_LABELS[s] ?? status}
    </Badge>
  );
}
